module.exports = __webpack_public_path__ + "img/hospitium-11.8a2bfff3.jpg";